import React, { Component } from 'react';
import './VideosRow.css';
import VideosRowItem from './VideosRowItem';

class VideosRow extends Component {
  render() {
    return (
      <div className="flex justify-around">
        <div className="grid grid-cols-1 xl:grid-cols-3 xl:gap-2 lg:grid-cols-2 lg:gap-4">
          {
            this.props.mintedVideos.map((video, ind) => {
              return (
                <VideosRowItem
                  key={ind}
                  video={video}
                  address={this.props.address}
                  selectItemForSubscribe={this.props.selectItemForSubscribe}
                  setTransactionStatus={this.props.setTransactionStatus}
                  subscriberStatuses={this.props.subscriberStatuses}
                />
              );
            })
          }
        </div>
      </div>
    );
  }
}

export default VideosRow;
